const TimelineQueryKeys = {
  all: ["statuses", "timeline"],
  timeline: (timelineId: string, pinKey: string | null) =>
    ["statuses", "timeline", timelineId, pinKey] as const,
};

export { TimelineQueryKeys };
